export const SUCCESS = 'ALERT_SUCCESS';
export const INFO = 'ALERT_INFO';
export const ERROR = 'ALERT_ERROR';
export const CLEAR = 'ALERT_CLEAR';
export const ALERT_GLOBAL_OPEN = 'ALERT_GLOBAL_OPEN';
export const ALERT_GLOBAL_CLOSE = 'ALERT_GLOBAL_CLOSE';
